import React from 'react';
import PropTypes from 'prop-types';

import BookingSoftwares, {
  MINDBODY,
  BOOKER,
} from './../../assets/BookingSoftwares';
import './index.scss';

export default class MindbodyVerify extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.onPreviousButtonClick = this.onPreviousButtonClick.bind(this);
  }

  componentDidMount() {
    // Get Bookings Software Info
    this.props.getBookingSoftware();
  }

  onPreviousButtonClick() {
    this.props.onBackClick();
  }

  onNextButtonClick() {
    const bookingSoftware =
      BookingSoftwares[this.props.softwares.selectedSoftware] || {};

    if (bookingSoftware.value === MINDBODY) {
      // Authorize with MB
      window.open(this.props.softwares.mindbodyActivationLink, '_blank');

      // Get activation status after a few seconds
      setTimeout(() => {
        this.props.getBookingSoftwareActivation();
      }, 4000);
    } else {
      this.props.getBookingSoftwareActivation();
    }
  }

  render() {
    const bookingSoftware =
      BookingSoftwares[this.props.softwares.selectedSoftware] || {};

    return (
      <div className="mindbody-verify">
        {this.props.softwares.isActivated === false ? (
          <p className="mindbody-verify__error">
            Authorization failed! Please carefully verify the details below and
            try again
          </p>
        ) : (
          undefined
        )}
        <p className="mindbody-verify__heading">
          Verify your business details and then authorize
        </p>
        <div className="mindbody-verify__details">
          <p>
            {this.props.softwares.info.STUDIO_NAME}
            <br />
            {this.props.softwares.info.STUDIO_LOCATION}
          </p>
          {this.props.business && this.props.business.info && (
            <div>{this.props.business.info.EMAIL}</div>
          )}
          {bookingSoftware.value === MINDBODY ? (
            <p>Studio Id: {this.props.softwares.studioId}</p>
          ) : (
            undefined
          )}
        </div>
        <div className="mindbody-verify__caption hide">
          <p>
            Please authorize TrueLark to sync with your{' '}
            {bookingSoftware.label || 'software'} schedule.
          </p>
          {bookingSoftware.value === MINDBODY ? (
            <p>
              Make sure you are logged in as “owner” on
              clients.mindbodyonline.com&nbsp;
              <strong>before</strong>&nbsp; clicking the button
            </p>
          ) : (
            undefined
          )}
          {bookingSoftware.value === BOOKER ? (
            <p>
              You can find this in your account settings.&nbsp;
              <strong>Booker PLUS</strong> account subscription is mandatory for
              API access
            </p>
          ) : (
            undefined
          )}
        </div>
        <div className="mindbody-verify__actions">
          <button
            className="btn btn--secondary btn--lg"
            onClick={this.onPreviousButtonClick}
          >
            Go Back
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
          >
            AUTHORIZE TrueLark
          </button>
        </div>
      </div>
    );
  }
}

MindbodyVerify.defaultProps = {
  getBookingSoftwareActivation: () => {},
  onBackClick: () => {},
  getBookingSoftware: () => {},
};

MindbodyVerify.propTypes = {
  onBackClick: PropTypes.func,
  getBookingSoftwareActivation: PropTypes.func,
  getBookingSoftware: PropTypes.func,
  softwares: PropTypes.shape({
    selectedSoftware: PropTypes.string,
    studioId: PropTypes.string,
    mindbodyActivationLink: PropTypes.string,
    isActivated: PropTypes.bool,
    info: PropTypes.shape({
      STUDIO_LOCATION: PropTypes.string,
      STUDIO_NAME: PropTypes.string,
    }),
  }).isRequired,
};
